import { memo, ReactElement } from 'react';
import Grid from '@material-ui/core/Grid';
import { ViewBox } from '../../component/Card';

interface Iconsprops {
  children: ReactElement;
  title?: string | number;
}

const Icons = ({ children, title }: Iconsprops) => {

  return (
    <Grid item>
      <ViewBox>
        {children}{title || ''}
      </ViewBox>
    </Grid>
  )
}

export default memo(Icons);
